// Loader.js (Reusable Loader Component)
import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Loader = () => (
  <Box
    sx={{
      position: "fixed", // Full-screen overlay
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "var(--loader-bg-color)", // Optional dimming
      zIndex: 9999, // On top of all content
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <CircularProgress />
  </Box>
);

export default Loader;


export const BtnLoader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "20px", // Keep height small to match button text size
      width: "20px",
    }}
  >
    <CircularProgress size={16} color="inherit" />
  </Box>
);
